var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { fontFamily, fontWeight } from "core/styles/snippets";
export var TimeInfo = styled.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  line-height: 1.5;\n  margin: 0 0 0.125rem 0;\n  font-size: 0.875rem;\n  color: #6a6a6a;\n  ", "\n  ", "\n"], ["\n  line-height: 1.5;\n  margin: 0 0 0.125rem 0;\n  font-size: 0.875rem;\n  color: #6a6a6a;\n  ", "\n  ", "\n"])), fontFamily.base, fontWeight.light);
var templateObject_1;
